import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'

// 企业
import company from './modules/company'
// 成果解析
import achievementParse from './modules/achievementParse'

Vue.use(Vuex)

const state = {
  emailStatus: true, // 标记邮箱是否被激活,
  // 用户的基本信息
  userInfo: sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')) : {},
  // 项目的基本信息 在项目详情的header组件中的project-info组件创建时设置的，每次刷新都会获取一遍项目信息
  // projectInfo: sessionStorage.getItem('projectInfo') ? JSON.parse(sessionStorage.getItem('projectInfo')) : {}
  projectInfo: {},
  interval: null // 获取未读消息数量的轮询
}

const options = {
  state,
  mutations,
  actions,
  modules: {
    company,
    achievementParse
  }
}

export default new Vuex.Store(options)



// WEBPACK FOOTER //
// ./src/store/index.js